import * as yup from "yup";

export const addLocaleValidator = yup.object({
  locale: yup.string().required("Locale is required"),
  version: yup.string().required("Field is required"),
});
